export const GetTokenFunc = () => {
  var cookies = document.cookie.split('; ');

  // Loop through each cookie to find the BearerToken
  var bearerToken;
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    if (cookie.startsWith('BearerToken=')) {
      // Extract the BearerToken value
      bearerToken = cookie.substring('BearerToken='.length);
      break;
    }
  }
  return bearerToken;
};
